import PeriprocedureelBeleidTARMonCloAsa from "../../../../src/client/lta-antistolling/periprocedureel-beleid-tar-mon-clo-asa.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidTARMonCloAsa,
  React
};